export default __webpack_public_path__ + "static/media/instagram.d6a4f1c1.svg";